import { Item, Level, LevelId, Section, SectionId, Subject, UserGroup } from 'able-lib'

export interface ScheduleStateInterface {
  schedule: {
    level: Level;
    subject: Subject;
    startTimestamp: number;
    endTimestamp: number;
  };
  userPicker: {
    levelId: LevelId;
    sectionId: SectionId;
  };
  schedules: Array<Item>;
  levels: Array<Level>;
  sections: Array<Section>;
  originalItems: Array<Item>;
  users: Array<UserGroup>;
}

export default function (): ScheduleStateInterface {
  const currentTimestamp = new Date().getTime()

  return {
    schedule: {
      level: null,
      subject: null,
      startTimestamp: currentTimestamp,
      endTimestamp: currentTimestamp + (60 * 60 * 1000)
    },
    userPicker: {
      levelId: null,
      sectionId: null
    },
    schedules: [],
    levels: [],
    sections: [],
    originalItems: [],
    users: []
  }
}
